import React from 'react'
import AsyncDropdown, { PropsWithAsyncDropdown } from 'core/elements/dropdown/AsyncDropdown'

const options = [
  { label: 'Image', value: 'image' },
  { label: 'Volume', value: 'volume' },
]

interface Props {}

export default function ClusterVMSourceType({
  name = 'sourceType',
  label = 'Boot VM From',
  compact = false,
  ...rest
}: PropsWithAsyncDropdown<Props>) {
  return <AsyncDropdown compact={compact} name={name} label={label} items={options} {...rest} />
}
